import React from "react";
import foto from "../../assets/12_Quienes somos/Astara/wearemobility-sec1.webp";
import logo from "../../assets/12_Quienes somos/Astara/astara_logo_white.webp";

/*eslint-disable */

declare const window: any;
const AstaraComponent: React.FC = () => {
  return (
    <div className="astara">
      <div className="title mb-4">
        <img src={logo} alt="" />
      </div>
      <div className="contenido row">
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="left">
            <div className="description mb-4">
              Somos una de las compañías líderes en movilidad a nivel global.
              Con un propósito claro, mejorar la vida de las personas y defender
              su derecho a moverse como prefieran.
            </div>
            <div className="description">MOVE. IT'S YOUR RIGHT.</div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
          <div className="right">
            <img src={foto} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AstaraComponent;
